import React from "react";
import {BiErrorCircle} from "react-icons/bi";
import ImportReportToolTip from "mapx-components/Modals/BulkImportModal/Report/Tooltip/importReportTooltip";

const BulkImportReportToolTip = (props: {
	reason?: string;
	error_reason?: string | null;
	status: string;
	url: string;
	color: string;
}) => {
	return (
		<div>
			<span data-tooltip-id={props.url}>
				<BiErrorCircle color={props.color} />
			</span>
			<ImportReportToolTip
				reason={props.reason}
				error_reason={props.error_reason}
				status={props.status}
				url={props.url}
			/>
		</div>
	);
};
export default BulkImportReportToolTip;
